var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("Schede")]),_c('CardsSearch')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }